import React from 'react';
import { MessageSquare, Code, Workflow, Zap } from 'lucide-react';
export function HowItWorks() {
  return <section id="how-it-works" className="py-16 md:py-24 bg-white" data-id="element-315">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-316">
        <div className="text-center mb-16" data-id="element-317">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-318">
            How Agentter.ai Works
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-319">
            Building powerful AI agents has never been easier. Just describe
            what you need, and we'll handle the rest.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-320">
          <div className="bg-gray-50 p-6 rounded-xl" data-id="element-321">
            <div className="bg-black text-white w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-322">
              <MessageSquare size={24} data-id="element-323" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-324">
              Describe
            </h3>
            <p className="text-gray-600" data-id="element-325">
              Explain what you need your agent to do in plain English.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-xl" data-id="element-326">
            <div className="bg-black text-white w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-327">
              <Code size={24} data-id="element-328" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-329">
              Connect
            </h3>
            <p className="text-gray-600" data-id="element-330">
              Connect to your existing software and data sources.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-xl" data-id="element-331">
            <div className="bg-black text-white w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-332">
              <Workflow size={24} data-id="element-333" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-334">
              Configure
            </h3>
            <p className="text-gray-600" data-id="element-335">
              Fine-tune your agent's behavior and permissions.
            </p>
          </div>
          <div className="bg-gray-50 p-6 rounded-xl" data-id="element-336">
            <div className="bg-black text-white w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-337">
              <Zap size={24} data-id="element-338" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-339">
              Activate
            </h3>
            <p className="text-gray-600" data-id="element-340">
              Deploy your agent and watch it automate your workflows.
            </p>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-341">
          <a href="#" className="inline-flex items-center text-black font-medium hover:text-gray-800 transition-colors" data-id="element-342">
            Learn more about our technology
            <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-343">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-344" />
            </svg>
          </a>
        </div>
      </div>
    </section>;
}